import MarkerPinIcon from "@redotech/redo-icons/marker-pin-01.svg";
import { Step } from "@redotech/redo-model/return-flow";
import { setReturnLocationsFromModel } from "@redotech/redo-model/return-flow-step-from-model";
import {
  isSetReturnLocationsStepValid,
  type SetReturnLocationsState,
  SPECIAL_LOCATION_ID,
} from "@redotech/redo-model/return-flow-step-valid";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const SET_RETURN_LOCATIONS = (
  Details: React.ComponentType<StepTypeDetailsProps<SetReturnLocationsState>>,
): StepType<SetReturnLocationsState, Step.SetReturnLocations> => ({
  layout() {
    return BlockLayout.FULL;
  },
  empty: { locations: [] },

  title: "Location",

  customTitle: (state) => state.customTitle,

  description: (state) => {
    const validCount = state.locations.filter((loc) => loc !== "").length;
    return `${validCount} location${validCount !== 1 ? "s" : ""}`;
  },

  Icon: MarkerPinIcon,
  iconColor: "success",

  Details(props) {
    return <Details {...props} />;
  },

  downstream: () => [],

  maxDownstream: () => 0,

  fromModel: (model) => setReturnLocationsFromModel(model),

  toModel: (state) => {
    const regularLocations: string[] = [];
    let useOriginalLocation = false;
    let useOriginalFulfillmentAddress = false;
    let useRedoManaged = false;

    for (const locationId of state.locations) {
      if (!locationId) {
        continue;
      }

      switch (locationId) {
        case SPECIAL_LOCATION_ID.ORIGINAL: {
          useOriginalLocation = true;

          break;
        }
        case SPECIAL_LOCATION_ID.SHIPMENT_ORIGIN: {
          useOriginalFulfillmentAddress = true;

          break;
        }
        case SPECIAL_LOCATION_ID.REDO_MANAGED: {
          useRedoManaged = true;

          break;
        }
        default: {
          regularLocations.push(locationId);
        }
      }
    }

    return {
      type: Step.SET_RETURN_LOCATIONS,
      locations: regularLocations,
      customTitle: state.customTitle,
      restockExternalLocationIds: state.restockExternalLocationIds,
      useOriginalLocation: useOriginalLocation || undefined,
      useOriginalFulfillmentAddress: useOriginalFulfillmentAddress || undefined,
      useRedoManaged: useRedoManaged || undefined,
    };
  },

  valid: (state) => isSetReturnLocationsStepValid(state).valid,

  stepDeleted: (state) => state,
});

export {
  SPECIAL_LOCATION_ID,
  type SpecialLocationId,
} from "@redotech/redo-model/return-flow-step-valid";
